export default {
  'shareCoupon.title': 'ส่งต่อคูปอง',
  'shareCoupon.success': 'ส่งต่อสำเร็จ',
  'shareCoupon.alt_text': 'ของขวัญของคุณมาถึงแล้ว! ไปดูกันเลย～',
  'shareCoupon.unit': 'ใบ',
  'shareCoupon.button': 'เปิดของขวัญของฉัน',
  'shareCoupon.notice_message':
    'รอให้เพื่อนรับคูปองภายใน 24 ชั่วโมง เมื่อรับแล้วจะถือว่าส่งต่อสำเร็จ; หากเลยกำหนด คูปองจะถูกคืนให้กับสมาชิก.',
  'shareCoupon.share_fail_message':
    'ส่งต่อไม่สำเร็จ, เนื่องจากเวอร์ชันของ LINE ล้าสมัย กรุณาอัปเดต LINE',
  'shareCoupon.wrong_quantity': 'จำนวนคูปองที่ต้องการส่งต่อไม่ถูกต้อง',
  'shareCoupon.wrong_product': 'คูปองนี้ไม่สามารถส่งต่อได้',
  'shareCoupon.fail': 'การส่งต่อไม่สำเร็จ',
  'shareCoupon.please_enter_quantity': 'กรุณาระบุจำนวนคูปองที่ต้องการส่งต่อ',
  'shareCoupon.you_have': 'คุณมีคูปองอยู่',
  'shareCoupon.next_step': 'ดำเนินการต่อ',
} as Record<string, string>;
